import { useMemo } from "react";
import { calculateDistance } from "../utils/calculateDistance";
import { isValidCoordinates } from "../utils/isValidCoordinates";
import { TargetLocation } from "../dtos/TargetLocation";

interface UseGeofenceResult {
  distanceToTarget: number | null;
  isWithinGeofence: boolean;
}

export const useGeofence = (
  coords: [number, number] | null,
  targetLocation: TargetLocation | null,
  radiusKm: number,
): UseGeofenceResult => {
  const distanceToTarget = useMemo(() => {
    if (!coords || !targetLocation) return null;
    if (
      !isValidCoordinates(coords[0], coords[1]) ||
      !isValidCoordinates(targetLocation.lat, targetLocation.lng)
    )
      return null;
    const d = calculateDistance(coords[0], coords[1], targetLocation.lat, targetLocation.lng);
    return Number.isFinite(d) ? d : null;
  }, [coords, targetLocation]);

  const isWithinGeofence = useMemo(
    () => distanceToTarget !== null && distanceToTarget <= radiusKm,
    [distanceToTarget, radiusKm],
  );

  return { distanceToTarget, isWithinGeofence };
};